import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from 'questionizer-core'
import styles from './index.scss?inline'
import './index.scss'

//let configPath = document!.querySelector('meta[name="febis-questionizer-config-url"]')?.getAttribute('content');
import config from "./config.json"

if (config !== undefined) {
  const host = document.getElementById('febis-questionizer');
  if (host){
    // @font-face must be in light DOM — browsers don't load fonts from Shadow DOM stylesheets
    if (!document.getElementById('febis-open-sans-fonts')) {
      const fontStyle = document.createElement('style');
      fontStyle.id = 'febis-open-sans-fonts';
      fontStyle.textContent = `
        @font-face { font-display: swap; font-family: 'Open Sans'; font-style: normal; font-weight: 300; src: url('https://questionizer.foerdermittelauskunft.de/de/foerderdata_v2/fonts/open-sans-v40-latin-300.woff2') format('woff2'); }
        @font-face { font-display: swap; font-family: 'Open Sans'; font-style: normal; font-weight: 400; src: url('https://questionizer.foerdermittelauskunft.de/de/foerderdata_v2/fonts/open-sans-v40-latin-regular.woff2') format('woff2'); }
        @font-face { font-display: swap; font-family: 'Open Sans'; font-style: normal; font-weight: 500; src: url('https://questionizer.foerdermittelauskunft.de/de/foerderdata_v2/fonts/open-sans-v40-latin-500.woff2') format('woff2'); }
        @font-face { font-display: swap; font-family: 'Open Sans'; font-style: normal; font-weight: 700; src: url('https://questionizer.foerdermittelauskunft.de/de/foerderdata_v2/fonts/open-sans-v40-latin-700.woff2') format('woff2'); }
      `;
      document.head.appendChild(fontStyle);
    }

    const shadow = host.attachShadow({ mode: 'open' });
    const mountPoint = document.createElement('div');
    
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styles);
    shadow.adoptedStyleSheets = [sheet];

    console.log("ADOPTED",sheet,  shadow.adoptedStyleSheets);

    shadow.appendChild(mountPoint);

      ReactDOM.createRoot(mountPoint).render(
      <React.StrictMode>
        <App config={config}/>
      </React.StrictMode>);
    }
  }else{
    console.warn("Keine Konfiguration gefunden");
  }